import { useQuery } from 'react-query';
import { getEmployeeBonuses } from 'RestAPIs/employees/employee-bonuses';
import { GetEmployeeBonusesProps } from 'RestAPIs/employees/employee-bonuses/types';

const useGetEmployeeBonuses = (
  {
    employeeId,
    startDate,
    endDate,
    buhTypeSvc,
    isEmployeePortal
  }: GetEmployeeBonusesProps,
  options: Record<string, any> = {},
  queryKeyPrefix = isEmployeePortal
    ? 'employeeBonusesPortal'
    : 'employeeBonusesCard'
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    [
      queryKeyPrefix,
      isEmployeePortal ? 'PORTAL' : 'CARD',
      employeeId,
      startDate,
      endDate,
      buhTypeSvc
    ],
    async () => {
      const { data } = await getEmployeeBonuses({
        employeeId,
        startDate,
        endDate,
        buhTypeSvc,
        isEmployeePortal
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeBonuses;
